import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './modules/guard/auth.guard';
import { AccountantGuard } from './modules/guard/accountant.guard';
import { AdvisorComponent } from './modules/advisor/advisor.component';
import { ProfileComponent } from "app/modules/profile/profile.component";
import { ResourceComponent } from "app/modules/resource/resource.component";
import { WelcomeComponent } from "app/modules/welcome/welcome.component";
import { SessionCheckComponent } from "app/modules/sessioncheck/sessioncheck.component";
import { PgfComponent } from "app/modules/pgf/pgf.component";
import { PgfIntroComponent } from "app/modules/pgf-intro/pgf-intro.component";
import { PgfResourcesComponent } from "app/modules/pgf-intro/pgf-resources.component";
import { PgfGrantsComponent } from 'app/modules/pgf/grants/grants.component';
import { PgfImapctsComponent} from "app/modules/pgf/impacts/impacts.component";
import { PgfActivitiesComponent } from 'app/modules/pgf/activities/activities.component';
import { PgfCharityComponent } from 'app/modules/pgf/charity/charity.component';
import { PgfImpactComponent} from "app/modules/pgf/impact/impact.component";
import { PgfYearActivityComponent } from 'app/modules/pgf/year-activity/year-activity.component';
import { PgfAllNewsComponent } from 'app/modules/pgf/all-news/all-news.component';
import { ClientErrorComponent } from './modules/clienterror/client-error.component';

import { PortfolioComponent }  from 'app/modules/portfolio/portfolio.component';
import { DocumentComponent }  from 'app/modules/document/document.component';
import { NotificationsComponent }  from 'app/modules/notifications/notifications.component';
import { CYR_DetailsComponent } from 'app/modules/details/CYR-details.component';
import { AICP_DetailsComponent } from 'app/modules/details/AICP-details.component';
import { CFCY_DetailsComponent } from 'app/modules/details/CFCY-details.component';
import { NetWorthComponent } from 'app/modules/net-worth/net-worth.component';
import {AccountantDocumentComponent} from "app/modules/document/accountant-document/accountant-document.component";

const routes: Routes = [
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  { path: 'welcome/:id', component: WelcomeComponent, canActivate: [AuthGuard] },
  { path: 'sessioncheck', component: SessionCheckComponent },
  { path: 'pgf', component: PgfComponent, canActivate: [AuthGuard] },
  { path: 'pgf/grants', component: PgfGrantsComponent, canActivate: [AuthGuard] },
  { path: 'pgf/impacts', component: PgfImapctsComponent, canActivate: [AuthGuard] },
  { path: 'pgf/activity', component: PgfActivitiesComponent, canActivate: [AuthGuard] },
  { path: 'pgf/charity/:id', component: PgfCharityComponent, canActivate: [AuthGuard] },
  { path: 'pgf/impact/:impact', component: PgfImpactComponent, canActivate: [AuthGuard] },
  { path: 'pgf/year-activity', component: PgfYearActivityComponent, canActivate: [AuthGuard] },
  { path: 'pgf-intro', component: PgfIntroComponent, canActivate: [AuthGuard] },
  { path: 'pgf/news', component: PgfAllNewsComponent, canActivate: [AuthGuard] },
  { path: 'pgf-intro/news', component: PgfAllNewsComponent, canActivate: [AuthGuard] },
  { path: 'pgf-resources', component: PgfResourcesComponent, canActivate: [AuthGuard] },
  { path: 'pgf-intro/:tag', component: PgfIntroComponent, canActivate: [AuthGuard] },
  { path: 'pgf-resources/:tag', component: PgfResourcesComponent, canActivate: [AuthGuard] },
  { path: 'advisor', component: AdvisorComponent, canActivate: [AuthGuard] },
  { path: 'advisor/:tag', component: AdvisorComponent, canActivate: [AuthGuard] },
  { path: 'details/cyr',  component: CYR_DetailsComponent, canActivate: [AuthGuard] },
  { path: 'details/aicp', component: AICP_DetailsComponent, canActivate: [AuthGuard] },
  { path: 'details/cfcy',  component: CFCY_DetailsComponent, canActivate: [AuthGuard] },
  { path: 'details/cyr/:id',  component: CYR_DetailsComponent, canActivate: [AuthGuard] },
  { path: 'details/aicp/:id', component: AICP_DetailsComponent, canActivate: [AuthGuard] },
  { path: 'details/cfcy/:id',  component: CFCY_DetailsComponent, canActivate: [AuthGuard] },
  { path: 'document',  component: AccountantDocumentComponent, canActivate: [AuthGuard], canMatch: [AccountantGuard] },
  { path: 'document',  component: DocumentComponent, canActivate: [AuthGuard] },
  { path: 'notifications',  component: NotificationsComponent, canActivate: [AuthGuard] },
  { path: 'portfolio/:id', component: PortfolioComponent, canActivate: [AuthGuard] },
  { path: 'portfolio', redirectTo: 'portfolio/', pathMatch: 'full' },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'profile/:tag', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'profile/:tag/:rerg', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'resource', component: ResourceComponent, canActivate: [AuthGuard] },
  { path: 'resource/:tag', component: ResourceComponent, canActivate: [AuthGuard] },
  { path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuard] },
  { path: 'welcome/:mode', component: WelcomeComponent, canActivate: [AuthGuard] }, // kept it only to support old welcome/success links
  { path: 'net-worth', component: NetWorthComponent, canActivate: [AuthGuard] }, // kept it only to support old welcome/success links
  { path: 'error/client/:code', component: ClientErrorComponent },
  { path: '**', component: ClientErrorComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule{
}
